import { useEffect } from "react";
import { usePlatformConfig } from "@/hooks/usePlatformConfig";

/**
 * Dynamically updates the favicon based on platform config.
 * Call once at app root level.
 */
export function useDynamicFavicon() {
  const { config, loading } = usePlatformConfig();

  useEffect(() => {
    if (loading) return;
    const faviconUrl = config.favicon_url;
    if (!faviconUrl) return;

    let link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
    link.type = faviconUrl.endsWith(".ico") ? "image/x-icon" : "image/png";
  }, [config.favicon_url, loading]);
}
